import AppearanceOption from 'owa-calendar-appearance-option/lib/AppearanceOption';
import loadCalendarMailboxConfiguration from './loadCalendarMailboxConfiguration';
var viewSubCategory = {
    key: 'view',
    titleStringKey: 'optionSubcategory_view',
    options: [AppearanceOption],
    onSelected: loadCalendarMailboxConfiguration,
};
export default viewSubCategory;
//# sourceMappingURL=viewSubCategory.js.map